import styled from 'styled-components';

interface StyledImageProps {
  $width?: string;
}

const StyledImage = styled.img<StyledImageProps>`
  width: ${props => props.$width || '100%'};
`

export default StyledImage;